import axios, {AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken} from 'axios';
import {SafeDigsClientBase, isAxiosError, throwException} from './SafeDigsClientBase';
import fileDownload from 'js-file-download';
import MNSwagClientConfiguration from '../Toolkit/Api/NSwagClientConfiguration';

export class SafeDigFileClient extends SafeDigsClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: MNSwagClientConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl('');
    }

    /**
     * @return Success
     */
    get(safeDigId: number, fileType: number, appArea: number, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + '/SafeDigFile/ListLatest?safeDigsId={safeDigId}&fileType={fileType}&appArea={appArea}';
        if(safeDigId === undefined || safeDigId === null) {
            throw new Error('The parameter \'safeDigId\' must be defined.');
        }
        url_ = url_.replace('{safeDigId}', encodeURIComponent('' + safeDigId));
        url_ = url_.replace('{fileType}', encodeURIComponent('' + fileType));
        url_ = url_.replace('{appArea}', encodeURIComponent('' + appArea));
        url_ = url_.replace(/[?&]$/, '');

        let options_: AxiosRequestConfig = {
            method: 'GET',
            url: url_,
            headers: {
                'Accept': 'text/plain'
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if(isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if(response.headers && typeof response.headers === 'object') {
            for(let k in response.headers) {
                if(response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if(status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : null as any;

            return throwException('Not Found', status, _responseText, _headers, result404);

        } else if(status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if(status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    getMisc(safeDigId: number, appArea: number, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + '/SafeDigFile/ListMiscellaneous?safeDigsId={safeDigId}&appArea={appArea}';
        if(safeDigId === undefined || safeDigId === null) {
            throw new Error('The parameter \'safeDigId\' must be defined.');
        }
        url_ = url_.replace('{safeDigId}', encodeURIComponent('' + safeDigId));
        url_ = url_.replace('{appArea}', encodeURIComponent('' + appArea));
        url_ = url_.replace(/[?&]$/, '');

        let options_: AxiosRequestConfig = {
            method: 'GET',
            url: url_,
            headers: {
                'Accept': 'text/plain'
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if(isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMisc(_response);
        });
    }

    protected processGetMisc(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if(response.headers && typeof response.headers === 'object') {
            for(let k in response.headers) {
                if(response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if(status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : null as any;

            return throwException('Not Found', status, _responseText, _headers, result404);

        } else if(status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if(status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    download(safeDigId: number, fileType: number, appArea: number, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + '/SafeDigFile/GetFile?safeDigId={safeDigId}&fileType={fileType}&appArea={appArea}';
        if(safeDigId === undefined || safeDigId === null) {
            throw new Error('The parameter \'safeDigId\' must be defined.');
        }
        url_ = url_.replace('{safeDigId}', encodeURIComponent('' + safeDigId));
        url_ = url_.replace('{fileType}', encodeURIComponent('' + fileType));
        url_ = url_.replace('{appArea}', encodeURIComponent('' + appArea));
        url_ = url_.replace(/[?&]$/, '');

        let options_: AxiosRequestConfig = {
            method: 'GET',
            url: url_,
            responseType: 'blob',
            headers: {
                'Accept': '*/*'
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if(isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if(response.headers && typeof response.headers === 'object') {
            for(let k in response.headers) {
                if(response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if(status === 200) {
            const filename = response.request.getResponseHeader('Filename');
            fileDownload(response.data, filename);
            return Promise.resolve<any>(null as any);
        } else if(status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500 = _responseText;
            result500 = resultData500 !== undefined ? resultData500 : null as any;

            return throwException('Server Error', status, _responseText, _headers, result500);
        } else if(status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : null as any;

            return throwException('File Not Found!', status, _responseText, _headers, result400);
        }

        return Promise.resolve<any>(null as any);
    }

    /**
     * @param safeDigsId (optional)
     * @param fileInfo (optional)
     * @param appArea (optional)
     * @return Success
     */
    listDocumentByType(safeDigsId: number | undefined, fileInfo: string | undefined, appArea: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/SafeDigFile/ListDocumentByType?";
        if (safeDigsId === null)
            throw new Error("The parameter 'safeDigsId' cannot be null.");
        else if (safeDigsId !== undefined)
            url_ += "safeDigsId=" + encodeURIComponent("" + safeDigsId) + "&";
        if (fileInfo === null)
            throw new Error("The parameter 'fileInfo' cannot be null.");
        else if (fileInfo !== undefined)
            url_ += "fileInfo=" + encodeURIComponent("" + fileInfo) + "&";
        if (appArea === null)
            throw new Error("The parameter 'appArea' cannot be null.");
        else if (appArea !== undefined)
            url_ += "appArea=" + encodeURIComponent("" + appArea) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListDocumentByType(_response);
        });
    }

    protected processListDocumentByType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if(status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : null as any;

            return throwException('Not Found', status, _responseText, _headers, result404);

        } else if(status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if(status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    downloadFile(safeDigFileId: number, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + '/SafeDigFile/DownloadFile?safeDigFileId={safeDigFileId}';
        if(safeDigFileId === undefined || safeDigFileId === null) {
            throw new Error('The parameter \'safeDigFileId\' must be defined.');
        }
        url_ = url_.replace('{safeDigFileId}', encodeURIComponent('' + safeDigFileId));
        url_ = url_.replace(/[?&]$/, '');

        let options_: AxiosRequestConfig = {
            method: 'GET',
            url: url_,
            responseType: 'blob',
            headers: {
                'Accept': '*/*'
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if(isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    changeFileState(body: ChangeFileStateRequest | undefined, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + '/SafeDigFile/ChangeState';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: 'PATCH',
            url: url_,
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Accept': 'text/plain'
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if(isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeFileState(_response);
        });
    }

    protected processChangeFileState(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if(response.headers && typeof response.headers === 'object') {
            for(let k in response.headers) {
                if(response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if(status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : null as any;

            return throwException('Bad Request', status, _responseText, _headers, result400);

        } else if(status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : null as any;

            return throwException('Not Found', status, _responseText, _headers, result404);

        } else if(status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409 = _responseText;
            result409 = resultData409 !== undefined ? resultData409 : null as any;

            return throwException('Conflict', status, _responseText, _headers, result409);

        } else if(status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if(status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    changeFileIncludeState(safeDigFileId: number, include: boolean, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + '/SafeDigFile/ChangeIncludeInPrint?safeDigFileId={safeDigFileId}&newState={newState}';
        if(safeDigFileId === undefined || safeDigFileId === null) {
            throw new Error('The parameter \'safeDigId\' must be defined.');
        }
        url_ = url_.replace('{safeDigFileId}', encodeURIComponent('' + safeDigFileId));
        url_ = url_.replace('{newState}', encodeURIComponent('' + include));
        url_ = url_.replace(/[?&]$/, '');

        let options_: AxiosRequestConfig = {
            method: 'PATCH',
            url: url_,
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Accept': 'text/plain'
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if(isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeFileIncludeState(_response);
        });
    }

    protected processChangeFileIncludeState(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if(response.headers && typeof response.headers === 'object') {
            for(let k in response.headers) {
                if(response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if(status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : null as any;

            return throwException('Bad Request', status, _responseText, _headers, result400);

        } else if(status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : null as any;

            return throwException('Not Found', status, _responseText, _headers, result404);

        } else if(status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409 = _responseText;
            result409 = resultData409 !== undefined ? resultData409 : null as any;

            return throwException('Conflict', status, _responseText, _headers, result409);

        } else if(status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if(status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    archiveFile(safeDigFileId: number, user: string, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + '/SafeDigFile/ArchiveFile?safeDigFileId={safeDigFileId}&user={user}';
        if(safeDigFileId === undefined || safeDigFileId === null) {
            throw new Error('The parameter \'safeDigId\' must be defined.');
        }
        url_ = url_.replace('{safeDigFileId}', encodeURIComponent('' + safeDigFileId));
        url_ = url_.replace('{user}', encodeURIComponent('' + user));
        url_ = url_.replace(/[?&]$/, '');

        let options_: AxiosRequestConfig = {
            method: 'PATCH',
            url: url_,
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Accept': 'text/plain'
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if(isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchiveFile(_response);
        });
    }

    protected processArchiveFile(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if(response.headers && typeof response.headers === 'object') {
            for(let k in response.headers) {
                if(response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if(status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if(status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    post(body: CreateSafeDigFileRequest | undefined, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + '/SafeDigFile/SaveFile';
        url_ = url_.replace(/[?&]$/, '');

        //const content_ = JSON.stringify(body);
        const content_ = new FormData();
        content_.append('safeDigsID', body?.safeDigsId!.toString()!);
        content_.append('fileType', body?.fileType!.toString()!);
        content_.append('appArea', body?.appArea!.toString()!);
        content_.append('lineSearchPositive', body?.lineSearchPositive!.toString()!);
        content_.append('fileInfo', body?.fileInfo!);
        content_.append('fileName', body?.fileName!);
        content_.append('startDate', body?.startDate?.toISOString() ?? '');
        content_.append('expiryDate', body?.expiryDate?.toISOString()!);
        content_.append('file', body?.file!, body?.file!.name);
        content_.append('user', body?.user!);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: 'POST',
            url: url_,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'text/plain'
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if(isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    postMisc(body: CreateSafeDigFileRequest | undefined, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + '/SafeDigFile/SaveMiscFile';
        url_ = url_.replace(/[?&]$/, '');

        //const content_ = JSON.stringify(body);
        const content_ = new FormData();
        content_.append('safeDigsID', body?.safeDigsId!.toString()!);
        content_.append('fileType', body?.fileType!.toString()!);
        content_.append('appArea', body?.appArea!.toString()!);
        content_.append('lineSearchPositive', body?.lineSearchPositive!.toString()!);
        content_.append('fileInfo', body?.fileInfo!);
        content_.append('fileName', body?.fileName!);
        content_.append('startDate', body?.startDate?.toISOString() ?? '');
        content_.append('expiryDate', body?.expiryDate?.toISOString()!);
        content_.append('file', body?.file!, body?.file!.name);
        content_.append('user', body?.user!);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: 'POST',
            url: url_,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'text/plain'
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if(isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if(response.headers && typeof response.headers === 'object') {
            for(let k in response.headers) {
                if(response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if(status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : null as any;

            return throwException('Bad Request', status, _responseText, _headers, result400);

        } else if(status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : null as any;

            return throwException('Not Found', status, _responseText, _headers, result404);

        } else if(status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409 = _responseText;
            result409 = resultData409 !== undefined ? resultData409 : null as any;

            return throwException('Conflict', status, _responseText, _headers, result409);

        } else if(status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if(status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
};

export class UpdateSafeDigFileRequest implements IUpdateSafeDigFileRequest {
    safeDigFilesId: number | undefined;
    safeDigsId: number | undefined;
    fileType: number | undefined;
    appArea: number | undefined;
    expiryDate: Date | undefined;
    lineSearchPositive: number | undefined;
    fileStatus: number | undefined;
    fileLocation: string | undefined;
    fileInfo: string | undefined;
    fileName: string | undefined;
    user: string | undefined;

    constructor(data?: IUpdateSafeDigFileRequest) {
        if(data) {
            for(var property in data) {
                if(data.hasOwnProperty(property)) {
                    (this as any)[property] = (data as any)[property];
                }
            }
        }
    }

    init(_data?: any) {
        if(_data) {
            this.safeDigFilesId = _data['safeDigFilesId'];
            this.safeDigsId = _data['safeDigsId'];
            this.fileType = _data['fileType'];
            this.appArea = _data['appArea'];
            this.expiryDate = _data['expiryDate'] ? new Date(_data['receivedDate'].toISOString()) : undefined as any;
            this.lineSearchPositive = _data['lineSearchPositive'];
            this.fileStatus = _data['fileStatus'];
            this.fileLocation = _data['fileLocation'];
            this.fileInfo = _data['fileInfo'];
            this.fileName = _data['fileName'];
            this.user = _data['user'];
        }
    }

    static fromJS(data: any): UpdateSafeDigFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSafeDigFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['safeDigsId'] = this.safeDigsId;
        data['safeDigsFilesId'] = this.safeDigFilesId;
        data['fileType'] = this.fileType;
        data['appArea'] = this.appArea;
        data['expiryDate'] = this.expiryDate ? this.expiryDate.toISOString() : undefined as any;
        data['lineSearchPositive'] = this.lineSearchPositive;
        data['fileStatus'] = this.fileStatus;
        data['fileLocation'] = this.fileLocation;
        data['fileInfo'] = this.fileInfo;
        data['fileName'] = this.fileName;
        data['user'] = this.user;
        return data;
    }
};

export class ChangeFileStateRequest implements IChangeFileStateRequest {
    safeDigsId: number | undefined;
    fileType: number | undefined;
    fileArea: number | undefined;
    oldStatus: number | undefined;
    newStatus: number | undefined;
    user: string | undefined;

    constructor(data?: IChangeFileStateRequest) {
        if(data) {
            for(var property in data) {
                if(data.hasOwnProperty(property)) {
                    (this as any)[property] = (data as any)[property];
                }
            }
        }
    }

    init(_data?: any) {
        if(_data) {
            this.safeDigsId = _data['safeDigsId'];
            this.fileType = _data['fileType'];
            this.fileArea = _data['fileArea'];
            this.oldStatus = _data['oldStatus'];
            this.newStatus = _data['newStatus'];
            this.user = _data['user'];
        }
    }

    static fromJS(data: any): ChangeFileStateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeFileStateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['safeDigsId'] = this.safeDigsId;
        data['fileType'] = this.fileType;
        data['fileArea'] = this.fileArea;
        data['oldStatus'] = this.oldStatus;
        data['newStatus'] = this.newStatus;
        data['user'] = this.user;
        return data;
    }
};

export class CreateSafeDigFileRequest implements ICreateSafeDigFileRequest {
    safeDigsId: number | undefined;
    fileType: number | undefined;
    appArea: number | undefined;
    lineSearchPositive: boolean | undefined;
    startDate: Date | undefined;
    expiryDate: Date | undefined;
    file: File | undefined;
    fileInfo: string | undefined;
    fileName: string | undefined;
    user: string | undefined;

    constructor(data?: ICreateSafeDigFileRequest) {
        if(data) {
            for(var property in data) {
                if(data.hasOwnProperty(property)) {
                    (this as any)[property] = (data as any)[property];
                }
            }
        }
    }

    init(_data?: any) {
        if(_data) {
            this.safeDigsId = _data['safeDigsId'];
            this.fileType = _data['fileType'];
            this.appArea = _data['appArea'];
            this.lineSearchPositive = _data['lineSearchPositive'];
            this.startDate = _data['startDate'];
            this.expiryDate = _data['expiryDate'];
            this.file = _data['file'];
            this.fileInfo = _data['fileInfo'];
            this.fileName = _data['fileName'];
            this.user = _data['user'];
        }
    }

    static fromJS(data: any): CreateSafeDigFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSafeDigFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['safeDigsId'] = this.safeDigsId;
        data['fileType'] = this.fileType;
        data['appArea'] = this.appArea;
        data['lineSearchPositive'] = this.lineSearchPositive;
        data['startDate'] = this.startDate;
        data['expiryDate'] = this.expiryDate;
        data['file'] = this.file;
        data['fileInfo'] = this.fileInfo;
        data['fileName'] = this.fileName;
        data['user'] = this.user;
        return data;
    }
}

export interface ICreateSafeDigFileRequest {
    safeDigsId: number | undefined;
    fileType: number | undefined;
    appArea: number | undefined;
    lineSearchPositive: boolean | undefined;
    startDate: Date | undefined;
    expiryDate: Date | undefined;
    file: File | undefined;
    fileInfo: string | undefined;
    fileName: string | undefined;
    user: string | undefined;
};

export interface IUpdateSafeDigFileRequest {
    safeDigFilesId: number | undefined;
    safeDigsId: number | undefined;
    fileType: number | undefined;
    appArea: number | undefined;
    expiryDate: Date | undefined;
    lineSearchPositive: number | undefined;
    fileStatus: number | undefined;
    fileLocation: string | undefined;
    fileInfo: string | undefined;
    fileName: string | undefined;
    user: string | undefined;
};

export interface IChangeFileStateRequest {
    safeDigsId: number | undefined;
    fileType: number | undefined;
    fileArea: number | undefined;
    oldStatus: number | undefined;
    newStatus: number | undefined;
    user: string | undefined;
};